module.exports = __webpack_public_path__ + "img/api_blue.68056c35.svg";